/* eslint-disable import/no-named-default */
import {default as constants} from './constants';
/* eslint-enable import/no-named-default */

export {constants};
export default {constants};
